import "./SupportRequest.module.css";
import Header from "@/reusable_sections/Header";
import SupportHero from "./sections/SupportHero";
import SupportContact from "./sections/SupportContact";
import Workflow from "./sections/Workflow";
import Footer from "@/reusable_sections/Footer";
export default function SupportRequestPage() {
  return <div>
      <Header />
      <SupportHero />
      <SupportContact />
      <Workflow />
      <Footer />
    </div>;
}